import { createStyles } from "@mantine/core";

export const useServicePlanStyles = createStyles((theme) => ({
  servicePlanContainer: {
    width: "100%",
    paddingBlock: "20px",
  },

  stepper: {
    "& .mantine-Stepper-step": {
      backgroundColor: "var(--app-surface)",
      cursor: "pointer",
    },
    "& .mantine-Stepper-stepIcon": {
      backgroundColor: "var(--app-surface-2)",
      border: "2px solid var(--app-border)",
      color: "var(--app-text-muted)",
      "&[data-completed]": {
        backgroundColor: "var(--app-primary)",
        borderColor: "var(--app-primary)",
        color: "var(--app-on-primary)",
      },
      "&[data-progress]": {
        backgroundColor: "var(--app-primary)",
        borderColor: "var(--app-primary)",
        color: "var(--app-on-primary)",
      },
    },
    "& .mantine-Stepper-stepLabel": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "14px",
      color: "var(--app-text)",
    },
    "& .mantine-Stepper-stepDescription": {
      fontFamily: "Inter, sans-serif",
      fontSize: "12px",
      color: "var(--app-text-muted)",
    },
  },

  stepContent: {
    marginTop: "30px",
    minHeight: "400px",
  },

  navigationButtons: {
    paddingTop: "20px",
    borderTop: "1px solid var(--app-border)",
    marginTop: "30px",
  },

  formSection: {
    marginBottom: "24px",
  },

  sectionTitle: {
    fontFamily: "Inter, sans-serif",
    fontSize: "18px",
    fontWeight: 600,
    color: "var(--app-text)",
    marginBottom: "16px",
  },

  accordion: {
    "& .mantine-Accordion-control": {
      backgroundColor: "var(--app-tint-purple)",
      borderTopLeftRadius: "12px",
      borderTopRightRadius: "12px",
      borderBottom: "1px solid var(--app-border)",
      padding: "16px 20px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "16px",
      color: "var(--app-text)",
      "&:hover": {
        backgroundColor: "var(--app-tint-purple)",
      },
    },
    "& .mantine-Accordion-content": {
      backgroundColor: "var(--app-surface)",
      borderBottomLeftRadius: "12px",
      borderBottomRightRadius: "12px",
      padding: "20px",
    },
    "& .mantine-Accordion-item": {
      border: "1px solid var(--app-border)",
      borderRadius: "12px",
      marginBottom: "12px",
      overflow: "hidden",
    },
    "& .mantine-Accordion-chevron": {
      color: "var(--app-text-muted)",
    },
  },

  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  checkboxItem: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  checkboxAndLabelStyle: {
    "& .mantine-Checkbox-body": {
      alignItems: "center",
    },
    "& .mantine-Checkbox-label": {
      backgroundColor: "var(--app-surface-2)",
      color: "var(--app-text)",
      padding: "5px 10px",
      borderRadius: "16px",
      marginLeft: "8px",
      fontFamily: "Inter",
      fontSize: "12px",
      fontWeight: 500,
      cursor: "pointer",
    },
    "& svg": {
      color: "var(--app-text) !important",
    },
    "& input": {
      borderRadius: 6,
      cursor: "pointer",
    },
    "& input:checked": {
      backgroundColor: "var(--app-surface-2)",
      borderColor: "var(--app-text)",
    },
  },

  textInput: {
    marginLeft: "28px",
    "& input": {
      backgroundColor: "var(--app-surface)",
      border: "1px solid var(--app-border)",
      borderRadius: "8px",
      boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 400,
      color: "var(--app-text)",
      "&:focus": {
        borderColor: "var(--app-text)",
      },
    },
  },

  subCheckboxItem: {
    marginLeft: "30px",
  },

  emergencyContact: {
    backgroundColor: "var(--app-surface-2)",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
  },

  signatureBox: {
    border: "2px dashed var(--app-border)",
    borderRadius: "8px",
    padding: "24px",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    backgroundColor: "var(--app-surface)",
    "&:hover": {
      borderColor: "var(--app-primary)",
      backgroundColor: "var(--app-tint-amber)",
    },
  },

  signatureCanvas: {
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    cursor: "crosshair",
  },

  fieldGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "16px",
  },

  dateRangePicker: {
    "& .mantine-DateRangePicker-input": {
      backgroundColor: "var(--app-surface-2)",
      border: "1px solid var(--app-border)",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
    },
  },

  select: {
    "& .mantine-Select-input": {
      backgroundColor: "var(--app-surface-2)",
      border: "1px solid var(--app-border)",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
    },
  },

  input: {
    "& input, & textarea": {
      backgroundColor: "var(--app-surface-2)",
      border: "1px solid var(--app-border)",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
      "&:focus": {
        borderColor: "var(--app-primary)",
        backgroundColor: "var(--app-surface)",
      },
    },
  },

  multiSelect: {
    "& .mantine-MultiSelect-input": {
      backgroundColor: "var(--app-surface-2)",
      border: "1px solid var(--app-border)",
      borderRadius: "8px",
      fontFamily: "Inter, sans-serif",
      minHeight: "42px",
    },
    "& .mantine-MultiSelect-value": {
      backgroundColor: "var(--app-tint-amber)",
      color: "#C4320A",
      borderRadius: "16px",
    },
  },

  clientDataContent: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  accordionStyle: {
    "& .mantine-Accordion-chevron": {
      transition: "transform 200ms ease",
      "& svg": {
        fontSize: 34,
        color: "var(--app-text)",
      },
      "&[data-active]": {
        transform: "rotate(180deg)",
      },
    },
    "& .mantine-Accordion-item": {
      backgroundColor: "var(--app-surface)",
      border: "1px solid var(--app-border)",
      borderRadius: 12,
    },
    "& .mantine-Accordion-control": {
      "& .display-on-close": {
        display: "none !important",
      },
      '&[aria-expanded="false"]': {
        "& .display-on-close": {
          display: "block !important",
        },
      },
      '&[aria-expanded="true"] .display-on-close': {
        display: "none !important",
      },
      "& .mantine-Accordion-label": {
        fontSize: 16,
        fontWeight: 500,
        color: "var(--app-text)",
        fontFamily: "Inter",
      },
    },
    "& .mantine-Accordion-content": {
      padding: "24px 13px",
      borderTop: "1px solid var(--app-border)",
    },
    // "& .mantine-Accordion-item:last-child": {
    //   borderBottom: "none",
    // },
  },
  fieldsAccordion: {
    "& .mantine-Accordion-item": {
      backgroundColor: "var(--app-surface)",
      border: "1px solid var(--app-border)",
      borderRadius: 10,
    },
    "& .mantine-Accordion-chevron": {
      transition: "transform 200ms ease",
      "& svg": {
        fontSize: 24,
        color: "var(--app-text-muted)",
      },
      "&[data-active]": {
        transform: "rotate(180deg)",
      },
    },
    "& .mantine-Accordion-control": {
      backgroundColor: "var(--app-tint-purple)",
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      "& .display-on-close": {
        display: "none !important",
      },
      '&[aria-expanded="false"]': {
        borderRadius: 10,
        "& .display-on-close": {
          display: "block !important",
        },
      },
      '&[aria-expanded="true"] .display-on-close': {
        display: "none !important",
      },
      "& .mantine-Accordion-label": {
        fontSize: 14,
        fontWeight: 600,
        color: "var(--app-text)",
        fontFamily: "Inter",
        paddingBlock: 10,
      },
    },
    "& .mantine-Accordion-content": {
      padding: "11px 9px",
      borderTop: "1px solid var(--app-border)",
    },
  },

  inputStyle: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "var(--app-text)",
      },
      "& .mantine-Textarea-input": {
        height: 153,
        overflowY: "auto",
      },
      "& .mantine-Select-rightSection svg": {
        color: "var(--app-text-muted)",
      },
    },
    "& .mantine-DateInput-wrapper": {
      outline: "4px solid var(--app-border)",
      "& .mantine-DateInput-icon": {
        "& svg": {
          color: "var(--app-text)",
          fontSize: 18,
        },
      },
      "& .mantine-DateInput-input": {
        paddingLeft: 36,
        fontWeight: 600,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  diagnosisBoxLabel: {
    color: "var(--app-text)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    alignItems: "center",
    gap: 12,
    marginBottom: 6,
  },
  diagnosisBox: {
    borderRadius: 8,
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "10px 14px",
    height: 153,
    overflowY: "auto",
  },
  diagnosisBoxItemsFlex: {
    gap: "12px",
    flexWrap: "wrap",
  },
  diagnosisBoxItem: {
    alignItems: "center",
    gap: 4,
    padding: "4px 10px",
    height: "fit-content",
    width: "fit-content",
    borderRadius: 16,
    backgroundColor: "var(--app-surface-2)",
    "& p": {
      margin: 0,
      whiteSpace: "nowrap",
      fontFamily: "Inter",
      fontSize: 14,
      fontWeight: 500,
      color: "var(--app-text)",
    },
    "& svg": {
      fontSize: 24,
      color: "var(--app-text-muted)",
    },
  },
  signRow: {
    alignItems: "flex-end",
    gap: 10,
  },
  signatureInfoRow: {
    alignItems: "flex-end",
    width: "85%",
    gap: 10,
    marginInline: "auto",
    marginBottom: 50,
    flexWrap: "wrap",
    "@media (max-width: 600px)": {
      width: "100%",
      "& > *": {
        width: "100%",
        flex: "unset",
      },
    },
  },
  btnStyle: {
    padding: "0px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-primary)",
    backgroundColor: "var(--app-primary)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-on-primary)",
    "& .mantine-Button-label": {
      gap: 8,
    },
    ":hover": {
      backgroundColor: "var(--app-primary)",
      opacity: 0.8,
    },
  },
  signBtn: {
    fontSize: 14,
    height: 40,
    padding: "0px 16px",
  },
  greenBtnStyle: {
    backgroundColor: "#00A63E",
    borderColor: "#00A63E",
    fontSize: 14,
    fontWeight: 500,
    color: "#FFF",
    ":hover": {
      backgroundColor: "#00A63E",
      opacity: 0.8,
    },
  },
  requestSignatureBtn: {
    border: "1px solid var(--app-tint-red)",
    backgroundColor: "var(--app-tint-red)",
    fontSize: 14,
    color: "#DC2626",
    "& .mantine-Button-label svg": {
      color: "#DC2626",
    },
    ":hover": {
      backgroundColor: "var(--app-tint-red)",
      opacity: 0.8,
    },
    "&:disabled": {
      "& .mantine-Button-label svg": {
        color: "var(--app-text-muted)",
      },
    },
  },
  cancelBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface-2)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    ":hover": {
      backgroundColor: "var(--app-surface-2)",
      opacity: 0.8,
    },
  },
  inputFlex: {
    flex: 1,
  },
  sectionHdng: {
    fontSize: 24,
    fontWeight: 700,
    fontFamily: "Inter",
    color: "var(--app-text)",
    margin: 0,
    padding: "0px 10px 5px 10px",
    marginBottom: 20,
    borderBottom: "1px solid var(--app-border)",
  },
  signatureRequestCard: {
    maxWidth: 600,
    marginInline: "auto",
    backgroundColor: "var(--app-surface)",
    borderRadius: 12,
    outline: "0.50px var(--app-border) solid",
    outlineOffset: "-0.50px",
    boxShadow:
      "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
    // boxShadow:
    //   "0 20px 24px -4px rgba(16, 24, 40, 0.08), 0 8px 8px -4px rgba(16, 24, 40, 0.03)",
    padding: "23px 4px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& .warningIcon": {
      border: "8px solid var(--app-tint-red)",
      backgroundColor: "var(--app-tint-red)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: 50,
      width: 50,
      borderRadius: "50%",
      marginBottom: 14,
      "& svg": {
        fontSize: 18,
        color: "#D92D20",
      },
    },
    "& .cardHdng": {
      fontSize: 18,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "var(--app-text)",
      margin: 0,
    },
    "& .cardDiscription": {
      fontSize: 14,
      fontWeight: 400,
      fontFamily: "Inter",
      color: "var(--app-text-muted)",
      textAlign: "center",
      margin: 0,
      marginTop: 4,
    },
    "& .imgAndFieldParent": {
      alignItems: "flex-end",
      width: "80%",
      marginTop: 20,
      marginBottom: 10,
      gap: 10,
      "& > img": {
        height: 60,
      },
    },
  },
  btnsRow: {
    width: "90%",
    gap: 12,
  },
  requestSignBtn: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "1px solid var(--app-tint-red)",
    backgroundColor: "var(--app-tint-red)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#B42318",
    ":hover": {
      backgroundColor: "var(--app-tint-red)",
      opacity: 0.8,
    },
  },
  greenSignBtn: {
    padding: "0px 20px",
    borderColor: "var(--app-tint-green)",
    backgroundColor: "var(--app-tint-green)",
    fontSize: 14,
    fontWeight: 500,
    color: "#16A34A",
    ":hover": {
      backgroundColor: "var(--app-tint-green)",
      opacity: 0.8,
    },
  },
  cancelReqSignBtn: {
    padding: "10px 18px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    flex: 1,
    ":hover": {
      backgroundColor: "var(--app-surface)",
      opacity: 0.8,
    },
  },
  addSignatureContent: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    alignItems: "center",
    width: "fit-content",
    marginInline: "auto",
  },
  createSignatureContent: {
    display: "flex",
    flexDirection: "column",
    width: 620,
    marginInline: "auto",
    gap: 20,
    alignItems: "flex-end",
  },
  signatureAndInitialsWrapper: {
    alignItems: "center",
    flexWrap:"wrap",
    gap: 20,
    padding: "5px 15px 10px 15px",
    borderRadius: 10,
    border: "1px solid var(--app-border)",
    width: "fit-content",
    "& .userNameHdng": {
      margin: 0,
      fontSize: 16,
      fontWeight: 700,
      fontFamily: "Inter",
      color: "var(--app-text)",
      marginBottom: 3,
    },
  },
  signatureAndInitialsRow: {
    display: "flex",
    flexWrap: "wrap",
    borderRadius: 8,
    backgroundColor: "var(--app-surface-2)",
    padding: "12px 15px 16px 15px",
    gap: 18,
  },
  signAndInitialLabel: {
    color: "var(--app-text)",
    margin: 0,
    marginBottom: "6px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
  },
  signatureAndInitialsBox: {
    borderRadius: 8,
    backgroundColor: "var(--app-surface)",
    boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)",
    width: 190,
    maxWidth: 190,
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  textSignatureStyle: {
    fontSize: 28,
    fontWeight: 400,
    fontFamily: "Island Moments",
    color: "var(--app-text)",
    margin: 0,
  },
  signatureDrawImg: {
    width: "90%",
  },
  signatureImg: {
    width: "100%",
    objectFit: "cover",
    objectPosition: "center",
  },
  tabs: {
    width: "100%",
    fontFamily: "Inter",
  },
  tab_list: {
    background: "var(--app-surface-2)",
    borderRadius: "8px 8px 0px 0px",
    border: "none",
    justifyContent: "center",
  },
  tab: {
    color: "var(--app-text-muted) !important",
    fontFamily: "Inter",
    fontSize: 14,
    marginBottom: 0,
    padding: "20.2px 16px 20.2px 10px",
    fontWeight: 500,
    borderWidth: "2px !important",
    "& > span": {
      display: "flex",
      alignItems: "center",
      gap: 10,
    },
    "&:hover": {
      color: "var(--app-text) !important",
      background: "transparent",
    },
    "&[data-active]": {
      color: "var(--app-text) !important",
      borderColor: "var(--app-text)",
      "&:hover": {
        borderColor: "var(--app-text)",
      },
    },
  },

  signaturePadParent: {
    position: "relative",
    width: "100%",
    display: "inline-block",
    "& canvas": {
      border: "0.5px solid var(--app-border)",
      background: "#fff",
      cursor: "crosshair",
    },
  },
  textPad: {
    height: 160,
    backgroundColor: "var(--app-surface)",
    border: "0.5px solid var(--app-border)",
    padding: 10,
    "& input": {
      fontFamily: "'Island Moments', cursive",
      fontSize: 64,
      height: "unset",
      fontWeight: 400,
      color: "var(--app-text)",
      textAlign: "center",
    },
  },
  uploadBox: {
    height: 160,
    width: "100%",
    border: "0.5px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    padding: "0px",
    "& .uploadBoxInner": {
      height: "100%",
      width: "100%",
    },
  },
  previewBox: {
    padding: 10,
    minHeight: 160,
    width: "100%",
    border: "0.5px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
  },
  previewImg: {
    display: "block",
    objectFit: "contain",
    maxHeight: 200,
    width: "auto",
    margin: "auto",
  },
  selectedImgClose: {
    position: "absolute",
    top: 6,
    right: 6,
    borderRadius: "50%",
    backgroundColor: "var(--app-primary)",
    paddingLeft: 1,
    paddingBottom: 0.5,
  },
  signRequestStatus: {
    padding: "10px 16px",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    "&.pending": {
      border: "1px solid var(--app-tint-red)",
      backgroundColor: "var(--app-tint-red)",
      color: "var(--app-text)",
    },
    "&.success": {
      border: "1px solid var(--app-tint-green)",
      backgroundColor: "var(--app-tint-green)",
      color: "#00A991",
    },
  },
  voidSignReqBtn: {
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-text)",
    textDecoration: "underline",
  },
  inc_dec_Btn: {
    borderRadius: "50%",
    height: "26px",
    width: "26px",
    backgroundColor: "var(--app-surface)",
    filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))",
    padding: "0px",
  },
  requestedSignaturesEmails: {
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
    width: "80%",
    justifyContent: "center",
  },
  sendReqSignBtn: {
    maxWidth: "50%",
    width: "100%",
    minWidth: "fit-content",
    marginTop: 25,
  },
  emailAndBtnTag: {
    alignItems: "center",
    backgroundColor: "var(--app-surface-2)",
    borderRadius: 16,
    gap: 4,
    padding: "4px 10px",
    "& > p": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "var(--app-text)",
      margin: 0,
    },
    "& svg": {
      color: "var(--app-text-muted)",
    }
  },
   fullWidthAccordion:{
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },
  signaturesProgressText:{
    fontSize: 16,
    fontWeight: 500,
    fontFamily: "Inter",
    color: "var(--app-text)",
    margin: 0,
    marginTop: 10,
  }
}));
